import { createTqlQuery } from './tql';

// eslint-disable-next-line import/prefer-default-export
export { createTqlQuery };
